import { _ as a } from "./index660.mjs";
import { i as o } from "./index774.mjs";
var r = a, e = o, c = "[object AsyncFunction]", i = "[object Function]", s = "[object GeneratorFunction]", b = "[object Proxy]";
function g(n) {
  if (!e(n))
    return !1;
  var t = r(n);
  return t == i || t == s || t == c || t == b;
}
var j = g;
export {
  j as i
};
